// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3halW","label":"styles_label__qYqUL"};